export function getIconSrc(
  icon: string | undefined,
  baseAssetUrl: string
): string | undefined {
  if (!icon) return undefined;
  if (icon.startsWith('data:')) return icon;
  if (icon.includes('assets')) return `${baseAssetUrl}/${icon}`;
  return icon;
}
